import React from 'react'
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import useTranslation from 'Hooks/useTranslation'

const RadioLabel = ({ label }) => {
    return (
        <div className="jobLabel">
            <div className="labelName">{label}</div>
        </div>
    )
}

const ManageDateFormat = ({
    selectedTimeFormat,
    setSelectedTimeFormat,
    selectedTimeType,
    setSelectedTimeType,
    type,
    chartType
}) => {
    const translation = useTranslation();

    const onTimeModeChanged = (e) => {
        setSelectedTimeType(e.target.value)
        const dependencies = {
            'fromDatabase': ['time', 'dateTime'],
            'local': ['time', 'dateTime'],
            'elapsed': ['time', 'seconds']
        }

        if (dependencies[e.target.value] && !dependencies[e.target.value].includes(selectedTimeFormat)) {
            setSelectedTimeFormat(dependencies[e.target.value][0])
        }
    }

    const onTimeFormatChanged = (e) => {
        setSelectedTimeFormat(e.target.value)
        const dependencies = {
            'time': ['local', 'fromDatabase', 'elapsed'],
            'dateTime': ['local', 'fromDatabase'],
            'seconds': ['elapsed']
        }
        if (dependencies[e.target.value] && !dependencies[e.target.value].includes(selectedTimeType)) {
            setSelectedTimeType(dependencies[e.target.value][0])
        }
    }
    if (type === 'chartView' && chartType === 'timeBased')
        return <div>
            <div className="tr innerLikeRow">
                <div className="td text-bold format">
                    <RadioLabel label={translation.manageAxesModalFormatLabel} />
                </div>
                <div className="td main">
                    <div className="radioButtonGroup">
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="time"
                                checked={selectedTimeFormat === 'time'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>{translation.manageAxesModalTimeLabel}</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="dateTime"
                                checked={selectedTimeFormat === 'dateTime'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>{translation.manageAxesModalDateAndTimeLabel}</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="seconds"
                                checked={selectedTimeFormat === 'seconds'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>{translation.manageAxesModalSecondsLabel}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="tr hasBorderBottom innerLikeRow">
                <div className="td text-bold mode">
                    <RadioLabel label={translation.manageAxesModalModeLabel} />
                </div>
                <div className="td main">
                    <div className="radioButtonGroup">
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="local"
                                checked={selectedTimeType === 'local'}
                                onChange={onTimeModeChanged}
                            />
                            <span>{translation.manageAxesModalLocalLabel}</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="fromDatabase"
                                checked={selectedTimeType === 'fromDatabase'}
                                onChange={onTimeModeChanged}
                            />
                            <span>{translation.manageAxesModalDatabaseLabel}</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="elapsed"
                                checked={selectedTimeType === 'elapsed'}
                                onChange={onTimeModeChanged}
                            />
                            <span>{translation.manageAxesModalElapsedLabel}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    else
        return <div>
            <div className="formContentBlock">
                <FormControl component="fieldset">
                    <FormLabel component="label" className={'radioLabel text-bold'}>Time Mode</FormLabel>
                    <div className="radioButtonGroup">
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="local"
                                checked={selectedTimeType === 'local'}
                                onChange={onTimeModeChanged}
                            />
                            <span>Local</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="fromDatabase"
                                checked={selectedTimeType === 'fromDatabase'}
                                onChange={onTimeModeChanged}
                            />
                            <span>Database</span>
                        </label>
                        {type !== 'eventLogger' && <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeType"
                                value="elapsed"
                                checked={selectedTimeType === 'elapsed'}
                                onChange={onTimeModeChanged}
                            />
                            <span>Elapsed</span>
                        </label>}
                    </div>
                </FormControl>
            </div>
            <div className="formContentBlock">
                <FormControl component="fieldset">
                    <FormLabel component="label" className={'radioLabel text-bold'}>{'Time Format'}</FormLabel>
                    <div className="radioButtonGroup">
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="time"
                                checked={selectedTimeFormat === 'time'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>Time</span>
                        </label>
                        <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="dateTime"
                                checked={selectedTimeFormat === 'dateTime'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>Date and Time</span>
                        </label>
                        {type !== 'eventLogger' && <label className="radioButtonLabel">
                            <input
                                type="radio"
                                name="timeFormat"
                                value="seconds"
                                checked={selectedTimeFormat === 'seconds'}
                                onChange={onTimeFormatChanged}
                            />
                            <span>Seconds</span>
                        </label>}
                    </div>
                </FormControl>
            </div>
        </div>
}

export default ManageDateFormat
